import Vue from "vue";

const actions = {
  async getMobileVersionInfoByPlatform(_, platform) {
    try {
      let response = await Vue.axios.get(`mobile/update-check/${platform}/1`);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      return {
        minVersion: response.data.data["min-supported-version"],
        targetVersion: response.data.data["target-version"]
      };
    } catch (e) {
      throw e;
    }
  },
  updateAppSupport(_, payload) {
    const { platform, minSupportedVersion, targetVersion } = payload;

    return Vue.axios
      .post("super/mobile-update-check/update", {
        platform: platform,
        min_supported_version: minSupportedVersion,
        target_version: targetVersion
      })
      .then(response => response)
      .catch(error => {
        throw error.response;
      });
  }
};

export default actions;
